import './SettingsRow.css';

/**
 * Single settings row — label left, control right.
 * @param {object} props
 * @param {string} props.label
 * @param {React.ReactNode} props.children
 */
export default function SettingsRow({ label, children, alignTop }) {
    return (
        // alignTop shifts label to top for tall controls like CopyBlock
        <div className={`settings-row${alignTop ? ' settings-row--top' : ''}`}>
            <span className="settings-row-label">{label}</span>
            <div className="settings-row-control">{children}</div>
        </div>
    );
}
